import { useMutation, useQueryClient } from '@tanstack/react-query';
import { pb } from '@/core/api';
import { useToast } from '@/components/ui/toast';

type Vars = { id: string; status: string; reason: string; force: boolean };

export function useStatusOverride() {
  const qc = useQueryClient();
  const { toast } = useToast();
  return useMutation({
    mutationFn: (v: Vars) =>
      pb.send(`/api/team-members/status/${v.id}`, {
        method: 'POST',
        body: { status: v.status, reason: v.reason, force: v.force },
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['team-members-admin'] });
      qc.invalidateQueries({ queryKey: ['approacher'] });
      toast('Estado actualizado', 'success');
    },
    onError: () => toast('Error al cambiar estado', 'error'),
  });
}
